export const iconFontAwesomeEditingSliders = (
	<i className="fa-solid fa-sliders"></i>
);
